













































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { DateUtils } from '../../util/dateUtils';
import { ApiRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { ServiceRequest } from '../../types/entity';
import { CommonUtils } from '../../util/commonUtils';
import { RescheduleRequest } from '../../types/request';
import { ToastEvent } from '../../types/event';
import { EventBus } from '../../main';
import { required } from 'vuelidate/lib/validators';
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
@Component({
    props: {
        request: Object,
    },
    validations: {
        requestDate: {
            required,
        },
    },
    data() {
        return {
            requestDate: '',
            requestTime: '',
            requestTimeZone: '',
        };
    },
})
export default class RescheduleRequestModal extends Vue {
    private show = false;
    private TimeZones = TimeZones;

    public mounted() {
        const serviceRequest = this.$props.request as ServiceRequest;
        const date = DateUtils.formatDate(serviceRequest.appointment.timestamp, 'YYYY-MM-DD',
            serviceRequest.appointment.timezone);
        const time = DateUtils.formatDate(serviceRequest.appointment.timestamp, 'HH:mm',
            serviceRequest.appointment.timezone);
        this.$data.requestTimeZone = serviceRequest.appointment.timezone;
        this.$data.requestTime = time;
        this.$data.requestDate = date;
        this.show = true;
    }

    private close() {
        this.$router.go(-1);
    }

    private async rescheduleRequest() {
        const iHttpService = ObjectFactory.getHttpService();
        const reschedule: RescheduleRequest = {
            appointmentDate: this.$data.requestDate,
            appointmentTime: this.$data.requestTime,
            timezone: this.$data.requestTimeZone,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${this.$props.request.id}/reschedule`,
            data: reschedule,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<ServiceRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_REQUEST_RESCHEDULED'),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }
}
